export enum ApiErrorsCode {
  ERROR_TO_UPLOAD_IMAGE = "ERROR_TO_UPLOAD_IMAGE",
  EMAIL_ALREADY_VERIFIED = "EMAIL_ALREADY_VERIFIED",
  VOUCHER_INVALID = "VOUCHER_INVALID",
}
